import * as Sentry from '@sentry/nextjs';
import Layout from 'components/Layout';
import { NextPageContext } from 'next';
import NextErrorComponent from 'next/error';
import Head from 'next/head';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Content } from './styles';

interface Props {
  statusCode?: number;
  hasGetInitialPropsRun?: boolean;
  err?: any;
}

const ErrorComponent = (props: Props) => {
  const { hasGetInitialPropsRun, err } = props;
  const { t } = useTranslation();

  // https://github.com/zeit/next.js/issues/8592
  if (!hasGetInitialPropsRun && err) {
    Sentry.captureException(err);
  }

  return (
    <Layout removeLanguagePicker>
      <Head>
        <title>{t('page.error.title')}</title>

        <meta key="robots" name="robots" content="noindex" />
      </Head>

      <Content>
        <h1>{t('page.error.title')}...</h1>
        <p dangerouslySetInnerHTML={{ __html: t('page.error.text-p1') }} />
        <p dangerouslySetInnerHTML={{ __html: t('page.error.text-p2') }} />
      </Content>
    </Layout>
  );
};

ErrorComponent.getInitialProps = async ({
  res,
  err,
  asPath,
}: NextPageContext) => {
  const errorInitialProps: any = await NextErrorComponent.getInitialProps({
    res,
    err,
  } as NextPageContext);

  // https://github.com/zeit/next.js/issues/8592
  errorInitialProps.hasGetInitialPropsRun = true;

  if (res?.statusCode === 404) {
    return { statusCode: 404 };
  }

  if (err) {
    Sentry.captureException(err);

    return errorInitialProps;
  }

  Sentry.captureException(
    new Error(`Error.getInitialProps missing data at path: ${asPath}`),
  );

  return errorInitialProps;
};

export default ErrorComponent;
